import React from 'react';
import { styled, Typography } from '@mui/material';

const Root = styled('section')(({ theme }) => ({
  padding: theme.spacing(1, 2),
}));

interface AssessmentUserNameProps {
  firstName: string | null;
}

export const AssessmentUserName = ({ firstName }: AssessmentUserNameProps) => {
  if (!firstName) {
    return null;
  }

  return (
    <Root aria-label="assessment-taker-name">
      <Typography
        variant="h5"
        component="h1"
        fontFamily="Roboto"
        fontWeight={500}
        color="text.primary"
      >
        Welcome,{' '}
        <Typography
          component="span"
          variant="h5"
          fontFamily="Roboto"
          fontWeight={500}
          color="primary"
        >
          {firstName}
        </Typography>
      </Typography>
    </Root>
  );
};
